<template>
    <section class="contact" id="contact">
      <div class="container">
        <div class="contact-content">
          <div class="contact-info">
            <h2>Prêt à démarrer ?</h2>
            <p class="contact-subtitle">Notre équipe est à votre disposition pour répondre à toutes vos questions et vous guider dans votre demande de financement.</p>
            
            <div class="contact-methods">
              <div class="contact-item">
                <div class="contact-icon">
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <path fill="#1cc48d" d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                </div>
                <div class="contact-details">
                  <h4>Téléphone</h4>
                  <p>+237 6 55 57 41 19</p>
                </div>
              </div>
              
              <div class="contact-item">
                <div class="contact-icon">
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <path fill="#1cc48d" d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <path fill="#1cc48d" d="M22 6l-10 7L2 6" />
                  </svg>
                </div>
                <div class="contact-details">
                  <h4>Email</h4>
                  <p>oasisfinace2@gmail.com</p>
                </div>
              </div>
              
              <div class="contact-item">
                <div class="contact-icon">
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <path fill="#1cc48d" d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle fill="#1cc48d" cx="12" cy="10" r="3" />
                  </svg>
                </div>
                <div class="contact-details">
                  <h4>Adresse</h4>
                  <p>184 TONGO, NGAOUNDERE </p>
                </div>
              </div>
            </div>
          </div>
          
          <div class="contact-form">
            <form @submit.prevent="submitForm">
              <h3>Envoyez-nous un message</h3>
              
              <div class="form-group">
                <input 
                  type="text" 
                  v-model="form.name" 
                  placeholder=" " 
                  required 
                />
                <label>Votre nom complet</label>
              </div>
              
              <div class="form-group">
                <input 
                  type="email" 
                  v-model="form.email" 
                  placeholder=" " 
                  required 
                />
                <label>Votre email</label>
              </div>
              
              <div class="form-group">
                <input 
                  type="tel" 
                  v-model="form.phone" 
                  placeholder=" " 
                />
                <label>Votre téléphone (optionnel)</label>
              </div>
              
              <div class="form-group">
                <select v-model="form.subject" required>
                  <option value="" disabled selected>Sélectionnez un sujet</option>
                  <option value="loan">Demande de prêt</option>
                  <option value="savings">Produits d'épargne</option>
                  <option value="info">Demande d'information</option>
                  <option value="other">Autre</option>
                </select>
              </div>
              
              <div class="form-group">
                <textarea 
                  v-model="form.message" 
                  placeholder=" " 
                  required
                ></textarea>
                <label>Votre message</label>
              </div>
              
              <button type="submit" class="submit-btn">
                <span v-if="!loading">Envoyer le message</span>
                <span v-else class="loading">
                  <svg viewBox="0 0 50 50">
                    <circle cx="25" cy="25" r="20" fill="none" stroke="#fff" stroke-width="4"></circle>
                  </svg>
                  Envoi en cours...
                </span>
              </button>
              
              <div v-if="success" class="form-success">
                <svg viewBox="0 0 24 24" width="24" height="24">
                  <path fill="#1cc48d" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
                </svg>
                Merci ! Votre message a bien été envoyé. Nous vous contacterons rapidement.
              </div>
              
              <div v-if="error" class="form-error">
                Une erreur s'est produite. Veuillez réessayer plus tard.
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'ContactSection',
    data() {
      return {
        form: {
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        },
        loading: false,
        success: false,
        error: false
      }
    },
    methods: {
      submitForm() {
        this.loading = true;
        this.success = false;
        this.error = false;
        
        // Simuler un envoi de formulaire
        setTimeout(() => {
          this.loading = false;
          this.success = true;
          
          // Réinitialiser le formulaire après 5 secondes
          setTimeout(() => {
            this.form = {
              name: '',
              email: '',
              phone: '',
              subject: '',
              message: ''
            };
            this.success = false;
          }, 5000);
        }, 1500);
      }
    }
  }
  </script>
  
  <style scoped>
  .contact {
    padding: 5rem 1rem;
    background: #0a2e38;
    color: white;
  }
  
  .container {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .contact-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 3rem;
  }
  
  .contact-info h2 {
    font-size: 2.2rem;
    margin-bottom: 1.5rem;
    line-height: 1.3;
  }
  
  .contact-subtitle {
    font-size: 1.1rem;
    opacity: 0.9;
    line-height: 1.6;
    margin-bottom: 2rem;
  }
  
  .contact-methods {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
  
  .contact-item {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
  }
  
  .contact-icon {
    background: rgba(28, 196, 141, 0.1);
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  
  .contact-details h4 {
    font-size: 1.1rem;
    margin-bottom: 0.3rem;
  }
  
  .contact-details p {
    opacity: 0.8;
    font-size: 0.95rem;
  }
  
  .contact-form {
    background: white;
    border-radius: 12px;
    padding: 2.5rem;
    box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  }
  
  .contact-form h3 {
    color: #0a2e38;
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    text-align: center;
  }
  
  .form-group {
    position: relative;
    margin-bottom: 1.5rem;
  }
  
  .form-group input,
  .form-group textarea,
  .form-group select {
    width: 100%;
    padding: 1rem;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 1rem;
    transition: all 0.3s ease;
    background: #f9f9f9;
  }
  
  .form-group input:focus,
  .form-group textarea:focus,
  .form-group select:focus {
    border-color: #1cc48d;
    outline: none;
    background: white;
    box-shadow: 0 0 0 3px rgba(28, 196, 141, 0.2);
  }
  
  .form-group textarea {
    min-height: 120px;
    resize: vertical;
  }
  
  .form-group select {
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 1rem center;
    background-size: 1em;
  }
  
  .form-group label {
    position: absolute;
    top: 1rem;
    left: 1rem;
    color: #777;
    pointer-events: none;
    transition: all 0.3s ease;
    background: #f9f9f9;
    padding: 0 0.3rem;
  }
  
  .form-group input:focus + label,
  .form-group input:not(:placeholder-shown) + label,
  .form-group textarea:focus + label,
  .form-group textarea:not(:placeholder-shown) + label {
    top: -0.6rem;
    left: 0.8rem;
    font-size: 0.8rem;
    background: white;
    color: #1cc48d;
  }
  
  .submit-btn {
    background: #1cc48d;
    color: white;
    border: none;
    padding: 1rem;
    border-radius: 8px;
    font-size: 1.1rem;
    font-weight: 600;
    width: 100%;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  }
  
  .submit-btn:hover {
    background: #17a97a;
    transform: translateY(-2px);
  }
  
  .loading svg {
    width: 20px;
    height: 20px;
    animation: rotate 1s linear infinite;
  }
  
  @keyframes rotate {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  
  .form-success,
  .form-error {
    margin-top: 1.5rem;
    padding: 1rem;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  .form-success {
    background: rgba(28, 196, 141, 0.1);
    color: #1cc48d;
  }
  
  .form-error {
    background: rgba(255, 0, 0, 0.1);
    color: #ff4d4d;
  }
  
  @media (max-width: 768px) {
    .contact-content {
      grid-template-columns: 1fr;
    }
    
    .contact {
      padding: 3rem 1rem;
    }
    
    .contact-form {
      padding: 1.5rem;
    }
  }
  </style>